var TransitionState;
(function (TransitionState) {
  TransitionState["hidden"] = "hidden";
  TransitionState["entering"] = "entering";
  TransitionState["visible"] = "visible";
  TransitionState["leaving"] = "leaving";
})(TransitionState || (TransitionState = {}));

export { TransitionState };
